<div id="mySidenav" class="sidenav" *ngIf="this.menuMobile==true" >
  <a *ngFor="let module of this.moduleData; let i = index">
    <a *ngIf="module.status=='True'">
      <a class="m-menubar vcenter menu-txt-d"
        [ngClass]="this.tabActive==module.name ? 'm-menubar important vcenter w menu-txt-d' : 'm-menubar vcenter w menu-txt-d'"
        routerLink="{{module.path}}" *ngIf="module.child==null || module.child==undefined || module.child.length==0" (click)="tabmevery(i);">
        <span class="tabcell">
          {{module.name}}
          <i class="fa fa-ale-right" aria-hidden="true" ></i>
        </span>
      </a>

      <a class="m-menubar vcenter w menu-txt-d"
        [ngClass]="this.tabActive==module.name ? 'm-menubar important vcenter w menu-txt-d' : 'm-menubar vcenter w menu-txt-d'"

        *ngIf="module.child!=null && module.child!=undefined && module.child.length!=0  " (click)="tabmevery(i);">
        <span class="tabcell pointer">
          {{module.name}}
          <i data-toggle="collapse" class="fa fa-angle-right"  ></i>
        </span>
      </a>

      <div  *ngIf="module.status=='True' && module.child!=null && module.child!=undefined && module.child.length!=0 && this.tabm[i]==true  && this.menuMobile==true">
        <a *ngFor="let submodule of module.child; let i = index">
          <a class="m-menuin vcenter menu-txt-c" routerLink="{{submodule.path}}"
            *ngIf="submodule.id==1 && submodule.status=='True'">
            <span class="tabcell bold">
              {{submodule.name}} <i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
          </a>
          <a class="m-menuin vcenter menu-txt-c" routerLink="{{submodule.path}}"
            *ngIf="submodule.id>1 && submodule.status=='True'">
            <span class="tabcell ">
              {{submodule.name}} <i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
          </a>
        </a>
        <a (click)="logout()" ui-sref="login" class="m-menuin lastlink vcenter" *ngIf="module.name=='Perfil'">
          <span class="tabcell pointer">
            Cerrar Sesi&oacute;n <i class="fa fa-times-circle" aria-hidden="true"></i>
          </span>
        </a>
      </div>
    </a>
  </a>
</div>
<!-- [END MENU MOVIL] -->

<div class="basicrow">
  <div class="htopbar ">
    <div class="container vcenter">
      <div class="tabcell">
        <div class="autorow pull-left">
          <div class="autorow pull-left d-twlv arrw">
            <select>
              <option>
                Empresas
              </option>
            </select>
          </div>

          <div class="autorow w-bar pull-left h-twlv mob-size">
            <a>Personas</a>
            <a class="on m-sides mob-mar">Wholesale</a>
          </div>

          <div class="autorow ml-htop pull-left h-twlv mob-pad">
            <div class="autorow g-bar pull-left mob-text">
              <i class="fa fa-phone" aria-hidden="true"></i>Preguntas y Apoyo en Servicio 787-273-9999 | <a href="mailto:miclarowholesaleapp@claropr.com" target="_blank"><b>miclarowholesaleapp&#64;claropr.com</b></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="menubar" *ngIf="this.session!='true'">
    <div class="container">
      <div class="autorow pull-left">
        <a class="mc-logo">
          <span class="autocont vcenter">
            <span class="tabcell">
              <img width="100%" src="../../assets/images/Claro-wholesale_logo2_150px.png">
            </span>
          </span>
        </a>
      </div>
      <div class="autorow pull-right">

        <div class="chatMovil1" (click)="this.chat()">
          <a><img width="100%" class="atenicon" src="../../assets/images/atenicon.png"> Chat</a>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="this.session=='true'" class="menubar" id="accordion">
    <div class="container rel">
      <div class="autorow pull-left">
        <a class="mc-logo" routerLink="/home">
          <span class="autocont vcenter">
            <span class="tabcell">
              <img width="100%" src="../../assets/images/Claro-wholesale_logo2_150px.png">
            </span>
          </span>
        </a>
      </div>

      <div class="autorow pull-left visible-web">
        <a *ngFor="let module of this.moduleData; let i = index">
          <a *ngIf="module.status=='True' && module.name!='Perfil'">
            <a class="menu-ls menu-txt-d mexpand"
              [routerLink]="module.child==null || module.child==undefined || module.child.length==0 ? module.path : []"
              [ngClass]="this.tabActive==module.name ? 'menu-ls menu-txt-d on mexpand' : 'menu-ls menu-txt-d mexpand'"
              data-toggle="collapse" (click)="tabmevery(i);" >
              <span class="autocont vcenter">
                <span class="tabcell pointer">
                  {{module.name}}
                </span>
              </span>
            </a>
          </a>
        </a>
      </div>

      <div class="autorow pull-right visible-movil">
        <div class="mnu-icon">
          <div class="autocont vcenter">
            <div class="tabcell">
              <i (click)="this.menuMobile=!this.menuMobile" class="fa fa-bars" aria-hidden="true"></i>

              <i (click)="this.menuMobile=!this.menuMobile" class="fa fa-times" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="menu-segundario visible-web">
        <div class="menu3">
          <div class="tabcell menu2"
            [ngStyle]="{'background':this.showMenuStatus === true ? '#fff' : '#ef3829','color':this.showMenuStatus === true ? '#ef3829' : '#fff' }"
            (click)="showMenu()">
            <span>Hola, {{this.userName | titlecase}}
              <i class="fa fa-angle-down" aria-hidden="true"></i>
            </span>
          </div>
          <div class="icono-menu"
            [ngStyle]="{'border-right':this.showMenuStatus === true ? '0px solid' : ' 1px solid' }">
            <i data-target="#tab" class="fa fa-user" aria-hidden="true"></i>
          </div>
        </div>
        <div *ngFor="let module of this.moduleData; let i = index">
          <div *ngIf="module.name=='Perfil'">
            <div class="menu-b" [ngStyle]="{'display':this.showMenuStatus === true ? 'block' : 'none' }">
              <a *ngFor="let submodule of module.child; let i = index">
                <a routerLink="{{submodule.path}}" (click)="emitEvent(submodule.path)" class="acc-links vcenter2"
                  *ngIf="module.status=='True' && submodule.status=='True'">
                  <span class="tabcell menu-b">
                    <span class="">{{submodule.name}}</span>
                    <span class="fa-rigth"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
                  </span>
                </a>
              </a>
            </div>
          </div>
        </div>
        <div class="menu-b" [ngStyle]="{'display':this.showMenuStatus === true ? 'block' : 'none' }">
          <a (click)="logout()" class="acc-links vcenter2 pointer">
            <span class="tabcell menu-b">
              <span class="">Cerrar Sesi&oacute;n</span>
              <span class="fa-rigth"><i class="fa fa-times-circle" aria-hidden="true"></i></span>
            </span>
          </a>
        </div>
      </div>
    </div>
    <div *ngFor="let module of this.moduleData; let i = index" class="panel-group visible-web">
      <div>
        <div  class="transitionMenu claro-sublinks" data-parent="#accordion"
          [hidden]="module.name=='Perfil'||module.child==null || module.child==undefined || module.child.length==0 "
          *ngIf="module.status=='True' && this.tabm[i]==true  ">
          <div class="subconts">
            <div class="basicrow roboto-m f-black f-bmed">
              <a routerLink="{{module.path}}" class="menu-txt-c">{{module.name}}</a>
            </div>
            <div class="basicrow roboto-r f-black f-med">
              <img class="submenu-icon" width="100%" src="../../assets/images/ico_manejoRecursos.svg"
                *ngIf="module.name=='Manejo de Cuenta'">
              <img class="submenu-icon" width="100%" src="../../assets/images/ico_resumen_de_factura-empresa-01.svg"
                *ngIf="module.name=='Pagos y Facturas'">
              <a *ngFor="let submodule of module.child; let i = index">
                <a *ngIf="i!=0 && submodule.status=='True'" class="autorow m-top-ii pull-left m-right-i menu-txt-c"
                  routerLink="{{submodule.path}}">
                  {{submodule.name}}
                </a>
              </a>
            </div>
          </div>
          <div class="bluemenumsg roboto-r vcenter">
            <div class="tabcell">
              La red donde todo es posible
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
